import request from './index'

export const mqttPushCarBasic=(carId,typeId)=>{
    return request({
        url:'/mqtt/push_carbasic',
        method:'post',
        data:{
            carid:carId,
			type:typeId
        }
    })
}

export const mqttPushCarWork=(workId,workType,carId)=>{
    return request({
        url:'/mqtt/push_carwork',
        method:'post',
        data:{
            missionId:workId,
			carid:carId,
			type:workType
        }
    })
}

export const mqttPushCancelAlarm=(id,carId)=>{
    return request({
        url:'/mqtt/push_cancelAlarm',
        method:'post',
        data:{
            id:id,
			carId:carId
        }
    })
}

export const mqttPushUserOffline = (editedUser) => {
	return request({
		url: '/mqtt/push_offline',
		method: 'post',
		data: {
			user: editedUser
		}
	})
}